import { ObservableArray, View } from "binder"
import { ServerSideDataLoader } from "uicomponents";
import { personnel, PersonnelPictureManipulationViewModel } from "./personnelPictureManipulation-viewModel"

export class PersonnelPictureManipulationView extends View<PersonnelPictureManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-380591FA-823E-4E6D-A261-53A5B27739A3"
    }
    loadHtml(): string {
        let element = require('./personnelPictureManipulation.html').default;
        let style = require('./personnelPictureManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set personnel(v: ObservableArray<personnel>) { this._personnel = v; } public get personnel(): ObservableArray<personnel> { return this._personnel;} private _personnel: ObservableArray<personnel>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
}
